import React from "react";

const PrivacyIcon = () => {
	return (
		<svg
			width="14"
			height="15"
			viewBox="0 0 14 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Privacy</title>
			<path
				d="M6.99984 14.9758C6.9272 14.9758 6.84921 14.9724 6.76588 14.9654C6.68255 14.9585 6.6088 14.9411 6.54463 14.9133C4.84282 14.3161 3.47935 13.2601 2.45421 11.7452C1.42907 10.2302 0.916504 8.57207 0.916504 6.77082V3.2052C0.916504 2.92061 0.993657 2.66457 1.14796 2.43707C1.30213 2.20943 1.5097 2.04562 1.77067 1.94562L6.51421 0.133115C6.6788 0.0689485 6.84067 0.0368652 6.99984 0.0368652C7.159 0.0368652 7.32088 0.0689485 7.48546 0.133115L12.229 1.94562C12.49 2.04562 12.6975 2.20943 12.8517 2.43707C13.006 2.66457 13.0832 2.92061 13.0832 3.2052V6.77082C13.0832 8.57207 12.5706 10.2302 11.5455 11.7452C10.5203 13.2601 9.15685 14.3161 7.45505 14.9133C7.39088 14.9411 7.31713 14.9585 7.2338 14.9654C7.15046 14.9724 7.07248 14.9758 6.99984 14.9758ZM6.99984 13.9375C8.44428 13.4896 9.63873 12.5937 10.5832 11.25C11.5276 9.90624 11.9998 8.41319 11.9998 6.77082V3.19707C11.9998 3.14374 11.9851 3.09568 11.9557 3.05291C11.9264 3.01013 11.885 2.97804 11.8315 2.95666L7.08796 1.14416C7.0613 1.13346 7.03192 1.12812 6.99984 1.12812C6.96775 1.12812 6.93838 1.13346 6.91171 1.14416L2.16817 2.95666C2.1147 2.97804 2.07331 3.01013 2.044 3.05291C2.01456 3.09568 1.99984 3.14374 1.99984 3.19707V6.77082C1.99984 8.41319 2.47206 9.90624 3.4165 11.25C4.36095 12.5937 5.55539 13.4896 6.99984 13.9375Z"
				fill="#5663F2"
			/>
		</svg>
	);
};

export default PrivacyIcon;
